import type { AnsweringSubjectsResponse } from "@repo/shared/types";
import { getWithToken } from "../_client";

/**
 * QL-505 — client-session mirror of the advisor's
 * `GET /internal/flow-instances/:id/answering-subjects`: who answers the
 * product assessment and the quiz, and (on a member link) which member this
 * session is.
 */
export function getPublicAnsweringSubjects(token: string) {
  return getWithToken<AnsweringSubjectsResponse>("/public/flow/answering-subjects", token);
}
